import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import AsyncSelect from 'components/ui/Editor/AsyncSelect';
import TinyMCEEditor from 'components/ui/Editor/tinymce-editor';
import PrimaryButton from 'components/ui/PrimaryButton';
import Spinner from 'components/ui/Spinner/spinner';
import { useFormik } from 'formik';
import useToggle from 'hooks/useToggle';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { useDeleteReportMutation } from 'redux/reducers/routine';
import { useReportDetailByIdQuery } from 'redux/reducers/user';
import { useGetAutoCompleteAdminList, useGetRoutineReportById, useSaveandUpadateRoutineReport } from 'service/admin.query';
import NewRoutineReport from './NewReport';
import { initialReportFormValues } from './Schema';



const ReportForm = () => {
  const { id } = useParams();
  const { data: routineDetails, isLoading: isLoadingRoutineDetails } = useReportDetailByIdQuery({
    id: Number(id) || 0
  });
  const [selectedMember, setSelectedMember] = useState<any[]>([]);

  const { mutateAsync: getAdminList, isLoading: isGettingAvailabel } = useGetAutoCompleteAdminList()


  const { data: reportContent, isLoading: isDownloading, refetch } = useGetRoutineReportById(id, !!id)

  const [deleteReport, { isLoading: isDeletingReport }] = useDeleteReportMutation();
  const [deleteModal, toggleDeleteModal] = useToggle(false);


  const onDeleteConfirm = () => {
    deleteReport(id)
      .unwrap()
      .then((res: unknown) => {
        toast.success('Report deleted Successfully');
      })
      .then(() => toggleDeleteModal())
      .catch((error: any) => {
        toast.error(error?.data?.detail);
      });
  };

  const { mutate: saveReport, isLoading: isSavingReport } = useSaveandUpadateRoutineReport()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialReportFormValues,
    onSubmit: async (values) => {
      const payload = { ...values, additional_information: values?.additional_information || "" };
      try {
        if (!payload?.introduction) return toast.error('Introduction is required');
        if (!payload?.opening_ceremony) return toast.error('Opening Ceremony is required');
        if (!payload?.closing_ceremony) return toast.error('Closing Ceremony is required');
        if (!payload?.submitted_to) return toast.error('Submitted To is required');
        if (!payload?.coordinator_remarks) return toast.error('coordinator_remarks To is required');
        if (!payload?.training_details) return toast.error('Training Details is required');
        if (!payload?.submitted_by) return toast.error('Submitted By is required');
        const payloadData = {
          payload,
          routineId: id
        }
        saveReport(payloadData, {
          onSuccess: (res: any) => {
            if (res?.data?.code == 200) {
              refetch()
            }
          }
        })
      }
      catch (e: any) {
        toast.error(e?.error?.data?.message || 'Something went Wrong!');
      }

    }
  })



  useEffect(() => {
    setSelectedMember(routineDetails?.data?.static_data?.faculty?.map((item: any) => ({ label: item.name, value: item.id })) || []);
    const ids = routineDetails?.data?.static_data?.faculty?.map((item: any) => (item.id)) || []
    if (routineDetails?.data?.static_data) {
      const staticData = routineDetails.data.static_data;
      formik.setValues(staticData);
      formik.setFieldValue('faculty', ids.map(String))
      if (staticData.date) {
        const formattedDate = moment(staticData.date).format('YYYY-MM-DD');
        formik.setFieldValue('date', formattedDate);
      }
    }
  }, [routineDetails]);

  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => console.log("Print success"),
  });


  const ListMemeberOptions = (input: string): Promise<any> => {
    return new Promise(async (resolve: any): Promise<any> => {
      // if(input?.length<3) return
      const payload = {
        pageNo: 1, pageSize: 10, search: input, query: input
      }
      var resp: any = await getAdminList(payload);

      const data = (resp?.data?.data)
      var arr =
        data?.map((c: any) => {
          return {
            label: `${c.first_name} ${c.middle_name ? c.middle_name : ""} ${c.last_name}`,
            value: c.id?.toString() || ''
          };
        });
      resolve(arr);
    });
  };

  return (
    <Container title="Report">
      {/* Hidden print target */}
      <div style={{ display: 'none' }}>
        <NewRoutineReport ref={componentRef} data={reportContent} />
      </div>
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirm}
        title="Delete Confirmations"
        isLoading={isDeletingReport}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>
      {isLoadingRoutineDetails ? (
        <Spinner />
      ) : (
        <div>
          <div className="row">
            <div className="col-9"></div>
            <div className="col-3 d-flex justify-content-around gap-2">
              {reportContent && (
                <PrimaryButton
                  title="Print Report"
                  type="button"
                  isLoading={isDownloading}
                  onClick={handlePrint}
                />
              )}
              {/* <PrimaryButton
                title="Download Report"
                type="button"
                isLoading={isDownloadingReport}
                onClick={() => {
                  if (routineDetails?.data?.report) {
                    window.open(backendURL + routineDetails?.data?.report, '_blank');
                  } else {
                    toast.warn('First generate report');
                  }
                }}
              /> */}
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="d-flex gap-4" >

                <AsyncSelect
                  containerClassName=" col-6"
                  loadOptions={ListMemeberOptions}
                  defaultOptions={true}
                  placeholder={'Type to search member...'}
                  value={selectedMember}
                  onChange={(ids: any) => formik.setFieldValue('faculty', Array.isArray(ids) ? ids.map(String) : [])}
                  onChangeOption={(opts: any[]) => setSelectedMember(opts ?? [])}
                  label={'Choose Faculty Member'}
                  isMulti={true}
                />
                <div className="col-6 d-flex align-items-end ">
                  <input
                    name="date"
                    type="date"
                    value={formik.values.date}
                    style={{
                      height: '38px',
                      width: '200px',
                      border: '1px solid hsl(0, 0%, 80%)',
                      borderRadius: '4px'
                    }}
                    onChange={(data) => formik.setFieldValue('date', data.target.value)}
                  />
                </div>
              </div>

              <TinyMCEEditor
                title='Submitted by:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('submitted_by', e)
                }}
                value={formik.values.submitted_by}
                id={id}

              />



              <TinyMCEEditor
                title='Submitted to:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('submitted_to', e)
                }}
                value={formik.values.submitted_to}
                id={id}


              />

              <TinyMCEEditor
                title='Introduction:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('introduction', e)
                }}
                value={formik.values.introduction}
                id={id}


              />



              <TinyMCEEditor
                title='Training Details:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('training_details', e)
                }}
                value={formik.values.training_details}
                id={id}


              />


              <TinyMCEEditor
                title='Opening Ceremony:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('opening_ceremony', e)
                }}
                value={formik.values.opening_ceremony}
                id={id}


              />



              <TinyMCEEditor
                title='Closing Ceremony:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('closing_ceremony', e)
                }}
                value={formik.values.closing_ceremony}
                id={id}


              />



              <TinyMCEEditor
                title='Co-ordinators Remarks:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('coordinator_remarks', e)
                }}
                value={formik.values.coordinator_remarks}
                id={id}


              />
              <TinyMCEEditor
                title='AdditionalInformation:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('additional_information', e)
                }}
                value={formik.values.additional_information}
                id={id}


              />



              <TinyMCEEditor
                title='Annex:'
                folderName='report'
                heigth={500}
                setValue={(e: any) => {
                  formik.setFieldValue('annex', e)
                }}
                value={formik.values.annex}
                id={id}


              />
              <div className="row mt-4">
                <div className="col-12 d-flex justify-content-end">
                  <PrimaryButton title="Submit" type="submit" isLoading={isSavingReport} />
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </Container>
  );
};

export default ReportForm;
